import { Component } from '@angular/core';
import { User } from '../../providers/providers';
import { UserData } from '../../providers/user-data';
import { ApiService } from '../../api-service/api-service';


import { SettingsPage } from '../settings/settings';
import { CategoryPage } from '../category/category';
import { LeaderBoardPage } from '../leaderboard/leaderboard'; 
//import { TasksPage } from '../tasks/tasks';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = CategoryPage;
  tab2Root = LeaderBoardPage;
  tab3Root = SettingsPage;
  currentUser:any;
  constructor(public user: User, public server:ApiService) {
      //this.currentUser = new UserData(this.user, this.server);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts